import React, { useMemo } from "react";
import { TrendingUp, Info } from "lucide-react";

import { DashboardCard } from "../DashboardCard";
import { CardHeader } from "../CardHeader";
import { DashboardDropdown } from "../DashboardDropdown";
import { GrowthChart } from "../charts/GrowthChart";

import { getEmployeeGrowthData } from "../../services/dashboardAnalytics";

const GROWTH_OPTIONS = [
  { value: "LAST_MONTH", label: "Last Month" },
  { value: "3_MONTHS", label: "Last 3 Months" },
  { value: "6_MONTHS", label: "Last 6 Months" },
  { value: "LAST_YEAR", label: "Last Year" },
];

export const EmployeeGrowthCard = React.memo(function EmployeeGrowthCard({
  employees,
  range,
  onRangeChange,
}) {
  const growth = useMemo(
    () => getEmployeeGrowthData(employees, range),
    [employees, range]
  );

  return (
    <DashboardCard>
      <CardHeader
        icon={TrendingUp}
        iconBg="#EFF6FF"
        iconColor="#2563EB"
        title="Employee Growth"
        action={
          <DashboardDropdown
            value={range}
            options={GROWTH_OPTIONS}
            onChange={onRangeChange}
          />
        }
      />

      <div className="text-xs text-slate-400 font-medium mb-1">
        Total Headcount Trend
      </div>

      <GrowthChart data={growth.points} />

      <div className="mt-3 flex items-center gap-2 bg-blue-50/70 text-blue-700 text-xs font-medium rounded-xl px-3 py-2.5">
        <Info size={14} className="shrink-0" />
        {growth.growthPct}% growth in {growth.rangeLabel}
      </div>
    </DashboardCard>
  );
});